import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M9.5 3C5.358 3 2 6.358 2 10.5S5.358 18 9.5 18s7.5-3.358 7.5-7.5S13.642 3 9.5 3zM9 6h1v1H9V6zm2 8H8v-1h1V9H8V8h2v5h1v1z',
  ],
  height: 20,
  width: 20,
});
